<template>
  <v-alert v-if="error" class="my-5" color="red" outlined dense>{{
    error
  }}</v-alert>
</template>

<script>
export default {
  name: "Signin",
  computed: {
    error() {
      return this.$store.state.error;
    }
  }
};
</script>
